/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'checkbox-selected': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M6 0h12a6 6 0 016 6v12a6 6 0 01-6 6H6a6 6 0 01-6-6V6a6 6 0 016-6zm11.605 8.304a1.01 1.01 0 00-1.454.01l-4.93 4.994L8.85 10.91a1.02 1.02 0 00-1.454 0l-.093.094a1.046 1.046 0 000 1.47l3.187 3.221a1.02 1.02 0 001.454 0l5.755-5.828a1.046 1.046 0 000-1.47l-.093-.093z" id="svgicon_checkbox-selected_a"/></defs><use _fill="#000" xlink:href="#svgicon_checkbox-selected_a" fill-rule="evenodd"/>'
  }
})
